import request_types from "./modules/request_types";
import cp_simulator from "./modules/cp_simulator";

export default {
  ...request_types,
  ...cp_simulator
}